/* AMERICAN BARBELL — "FORGE" shell behavior (header + mobile menu).
   Loaded on every page (defer). */
(function () {
  var topbar = document.querySelector('.fg-topbar');
  var header = document.querySelector('.fg-header');
  if (!header) return;

  // expose the real bar heights so CSS can offset the page content
  function setHeights() {
    var root = document.documentElement;
    root.style.setProperty('--fg-topbar-h', (topbar ? topbar.offsetHeight : 0) + 'px');
    root.style.setProperty('--fg-nav-h', header.offsetHeight + 'px');
  }
  setHeights();
  window.addEventListener('resize', setHeights);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeights);

  // announcement bar slides away on scroll; navbar docks to the top
  function onScroll() {
    var s = window.scrollY > 20;
    header.classList.toggle('scrolled', s);
    if (topbar) topbar.classList.toggle('up', s);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // mobile menu
  var mmenu = document.getElementById('fg-mmenu');
  var burger = document.getElementById('fg-burger');
  var mclose = document.getElementById('fg-mclose');

  function openMenu() {
    mmenu.classList.add('open');
    document.documentElement.classList.add('fg-lock');
    burger.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    mmenu.classList.remove('open');
    document.documentElement.classList.remove('fg-lock');
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }
  if (burger && mmenu) burger.addEventListener('click', openMenu);
  if (mclose && mmenu) mclose.addEventListener('click', closeMenu);
  if (mmenu) {
    mmenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mmenu.classList.contains('open')) closeMenu();
    });
  }
})();
